

export const extractYears = (timestamps) => {
  const yearSet = new Set();
  if (timestamps){
    try {
      timestamps.forEach(x => {
        const year = new Date(x).getFullYear();
        yearSet.add(year);
      })
    }catch(e){}
  }
  return Array.from(yearSet).sort((a, b) => a - b);
};




export const extractRangeProperties = (dataSeries)=>{
  if (!dataSeries || !dataSeries?.[0]?.data?.[0]?.data){
    return;
  }
  const timestamps = dataSeries[0].data[0].data.map(x=>x[0]);
  const n = timestamps.length;
  const years = extractYears(timestamps);
  const globalMin = timestamps[0];
  const globalMax = timestamps[n-1];


  return {
    years,
    globalMin,
    globalMax
  }
}

export const setDataGrouping = ({chart, enabled=true})=>{
  let levels = [
      {unit: 'day', count: 1}
  ]
  let grouping = chart.grouping();
  grouping.enabled(enabled);
  grouping.levels(levels);
}


export const rewindowChartData = (dataSeries, startDate, endDate)=>{
  const startTimestamp = new Date(startDate).getTime();
  const endTimestamp = new Date(endDate).getTime();


  const newDataSeries = dataSeries.map(plot => {
    const newPlot = {
      ...plot,
      data: plot.data.map(series => {
        const newSeries = {
          ...series,
          data: series.data.filter(row => {
            const timestamp = new Date(row[0]).getTime();
            return timestamp >= startTimestamp && timestamp <= endTimestamp;
          })
        };
        if (series.yScale) {
          newSeries.yScale = series.yScale;
        }

        if (series.stroke) {
          newSeries.stroke = series.stroke;
        }

        return newSeries;
      })
    };

    return newPlot;
  });

  return newDataSeries;
}